
      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

var $h59ig = parcelRequire("h59ig");

var $97EoA = parcelRequire("97EoA");
var $9a962763f3d52615$exports = {};
// Elemen untuk menampilkan daftar tugas
const $9a962763f3d52615$var$tasksContainer = document.getElementById('tasks-container');
// Fungsi untuk memuat tugas dari Netlify Functions
async function $9a962763f3d52615$var$loadTasks() {
    try {
        const response = await fetch('/api/getTasks'); // Memanggil API Netlify Functions
        const tasks = await response.json();
        if (tasks.length === 0) {
            $9a962763f3d52615$var$tasksContainer.innerHTML = '<p>No tasks available at the moment. Please check back later!</p>';
            return;
        }
        tasks.forEach((task)=>{
            const taskElement = document.createElement('div');
            taskElement.classList.add('task-item');
            taskElement.innerHTML = `
        <h3>${task.title}</h3>
        <p>${task.description}</p>
        <p><strong>Difficulty: </strong>${task.difficulty || 'Unknown'}</p>
        <button class="start-task-btn" data-task-id="${task.id}">Start Task</button>
        <div id="task-${task.id}" class="task-details" style="display:none;">
          <p><strong>Question:</strong> ${task.question}</p>
          <form id="task-answer-form-${task.id}" class="task-answer-form">
            <input type="text" name="answer" placeholder="Your answer" required>
            <input type="hidden" name="taskId" value="${task.id}">
            <button type="submit">Submit Answer</button>
          </form>
        </div>
      `;
            // Attach event listener to the start task button
            const startTaskBtn = taskElement.querySelector('.start-task-btn');
            startTaskBtn.addEventListener('click', ()=>{
                const taskDetails = taskElement.querySelector('.task-details');
                taskDetails.style.display = 'block';
                startTaskBtn.style.display = 'none';
            });
            // Attach event listener to the answer form submission
            const taskForm = taskElement.querySelector('.task-answer-form');
            taskForm.addEventListener('submit', (event)=>{
                event.preventDefault();
                const taskId = event.target.taskId.value;
                const answer = event.target.answer.value;
                $9a962763f3d52615$var$submitTaskAnswer(taskId, answer);
            });
            $9a962763f3d52615$var$tasksContainer.appendChild(taskElement);
        });
    } catch (error) {
        console.error('Error loading tasks: ', error);
        alert('Failed to load tasks: ' + error.message);
    }
}
// Fungsi untuk mengirim jawaban tugas
async function $9a962763f3d52615$var$submitTaskAnswer(taskId, answer) {
    try {
        const response = await fetch('/api/submitTaskAnswer', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                taskId: taskId,
                answer: answer
            })
        });
        if (!response.ok) throw new Error('Failed to submit task answer');
        const data = await response.json();
        alert('Task answer submitted successfully!');
    } catch (error) {
        console.error('Error submitting task answer: ', error);
        alert('Task submission failed: ' + error.message);
    }
}
// Memuat tugas saat halaman dimuat
window.addEventListener('load', $9a962763f3d52615$var$loadTasks);


// DOM Elements
const $35bcf84cb57e9221$var$loginBtn = document.getElementById("login-btn");
const $35bcf84cb57e9221$var$registerBtn = document.getElementById("register-btn");
const $35bcf84cb57e9221$var$logoutBtn = document.getElementById("logout-btn");
const $35bcf84cb57e9221$var$userNameDisplay = document.getElementById("username-display");
const $35bcf84cb57e9221$var$loginModal = document.getElementById("modal-login");
const $35bcf84cb57e9221$var$registerModal = document.getElementById("modal-register");
const $35bcf84cb57e9221$var$closeLoginModal = document.querySelector("#modal-login .close");
const $35bcf84cb57e9221$var$closeRegisterModal = document.querySelector("#modal-register .close");
const $35bcf84cb57e9221$var$profileImageInput = document.getElementById("profile-image-input");
// Event listener functions
function $35bcf84cb57e9221$var$toggleModal(modal, displayStyle) {
    modal.style.display = displayStyle;
}
// Initialize Modals
$35bcf84cb57e9221$var$loginBtn.addEventListener('click', ()=>$35bcf84cb57e9221$var$toggleModal($35bcf84cb57e9221$var$loginModal, 'block'));
$35bcf84cb57e9221$var$registerBtn.addEventListener('click', ()=>$35bcf84cb57e9221$var$toggleModal($35bcf84cb57e9221$var$registerModal, 'block'));
$35bcf84cb57e9221$var$closeLoginModal.addEventListener('click', ()=>$35bcf84cb57e9221$var$toggleModal($35bcf84cb57e9221$var$loginModal, 'none'));
$35bcf84cb57e9221$var$closeRegisterModal.addEventListener('click', ()=>$35bcf84cb57e9221$var$toggleModal($35bcf84cb57e9221$var$registerModal, 'none'));
// Check user login status on page load
window.addEventListener('load', ()=>{
    const user = JSON.parse(localStorage.getItem('user'));
    if (user) {
        $35bcf84cb57e9221$var$userNameDisplay.innerText = user.username;
        $35bcf84cb57e9221$var$toggleAuthUI(true); // Show logged-in UI
    } else {
        $35bcf84cb57e9221$var$userNameDisplay.innerText = '';
        $35bcf84cb57e9221$var$toggleAuthUI(false); // Show logged-out UI
    }
});
// Helper function to toggle authentication UI
function $35bcf84cb57e9221$var$toggleAuthUI(isLoggedIn) {
    $35bcf84cb57e9221$var$logoutBtn.style.display = isLoggedIn ? 'inline' : 'none';
    $35bcf84cb57e9221$var$loginBtn.style.display = isLoggedIn ? 'none' : 'inline';
    $35bcf84cb57e9221$var$registerBtn.style.display = isLoggedIn ? 'none' : 'inline';
}
// Event listeners for login and register forms
document.getElementById('login-form').addEventListener('submit', (0, $h59ig.handleLogin));
document.getElementById('register-form').addEventListener('submit', (0, $h59ig.handleRegister));
$35bcf84cb57e9221$var$logoutBtn.addEventListener('click', (0, $h59ig.handleLogout));
// Handle profile image upload
$35bcf84cb57e9221$var$profileImageInput.addEventListener('change', (0, $97EoA.handleProfileImageUpload));
// Load games and initialize pagination
(0, $9a962763f3d52615$exports.loadGames)(1); // Default to page 1
(0, $9a962763f3d52615$exports.handlePagination)(); // Initialize pagination


//# sourceMappingURL=index.44b86fa4.js.map
